import { useEffect } from "react";
import { useGetRefreshStatusQuery } from "../api/accountApiSlice";
import { useAppSelector } from "../store/hooks";

const POLLING_INTERVAL_MS = 30 * 1000; // 30 seconds

export function useRemoteRefreshWatcher() {
    const isLoggedIn = useAppSelector(
        (state) => !!state.userStoreState.user?.id
    );

    const { data } = useGetRefreshStatusQuery(undefined, {
        skip: !isLoggedIn,
        pollingInterval: POLLING_INTERVAL_MS,
        skipPollingIfUnfocused: true,
        refetchOnFocus: true
    });

    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }

        if (data?.shouldRefresh) {
            window.location.reload();
        }
    }, [isLoggedIn, data?.shouldRefresh]);
}
